import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app, db } from '@/config/firebase';

const FUNCTIONS_REGION = 'us-central1';
const QUALITATIVE_REPORT_COLLECTION = 'performance_evaluation_qualitative_reports';

export interface EvaluationQualitativeReportContent {
    overview: string[];
    excellence: Array<{
        title: string;
        body: string;
    }>;
    improvements: Array<{
        title: string;
        body: string;
    }>;
    pdi: Array<{
        title: string;
        body: string;
    }>;
    finalConsiderations: string[];
}

export interface GenerateEvaluationQualitativeReportResult {
    content: EvaluationQualitativeReportContent;
    cached: boolean;
    sourceHash: string;
    promptVersion: string;
    model: string;
}

export async function generateEvaluationQualitativeReport(params: {
    campaignId: string;
    collaboratorId: string;
}): Promise<GenerateEvaluationQualitativeReportResult> {
    const functions = getFunctions(app, FUNCTIONS_REGION);
    const callable = httpsCallable(functions, 'generateEvaluationQualitativeReport');
    const result = await callable(params);

    return result.data as GenerateEvaluationQualitativeReportResult;
}

export async function getCachedEvaluationQualitativeReport(params: {
    campaignId: string;
    collaboratorId: string;
}): Promise<EvaluationQualitativeReportContent | null> {
    const ref = doc(db, QUALITATIVE_REPORT_COLLECTION, `${params.campaignId}__${params.collaboratorId}`);
    const snapshot = await getDoc(ref);
    const content = snapshot.data()?.content;

    return content ? content as EvaluationQualitativeReportContent : null;
}

export async function saveEvaluationQualitativeReportOverride(params: {
    campaignId: string;
    collaboratorId: string;
    content: EvaluationQualitativeReportContent;
}): Promise<void> {
    const ref = doc(db, QUALITATIVE_REPORT_COLLECTION, `${params.campaignId}__${params.collaboratorId}`);

    await setDoc(ref, {
        campaignId: params.campaignId,
        collaboratorId: params.collaboratorId,
        content: params.content,
        manualOverride: true,
        status: 'ready',
        manualUpdatedAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
    }, { merge: true });
}
